/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid ui/pinning.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

const CLASS_START = 'data-grid-cell-pinned-start'
const CLASS_END = 'data-grid-cell-pinned-end'
const CLASS_START_LAST = 'data-grid-cell-pinned-start-last'
const CLASS_END_FIRST = 'data-grid-cell-pinned-end-first'

export interface PinnedCellInfo {
  side: 'start' | 'end'
  offset: number
  edge: boolean
  // A start offset that has to clear the (sticky) selection cell; expressed as a
  // CSS calc so the select-cell width stays a single source of truth in CSS.
  afterSelect: boolean
}

export interface GridPinning {
  columns: Record<string, PinnedCellInfo>
  select: PinnedCellInfo | null
}

export const applyPinnedCell = (cell: HTMLTableCellElement, info: PinnedCellInfo | null): void => {
  cell.classList.remove(CLASS_START, CLASS_END, CLASS_START_LAST, CLASS_END_FIRST)
  cell.style.insetInlineStart = ''
  cell.style.insetInlineEnd = ''

  if (!info) {
    return
  }

  if (info.side === 'start') {
    cell.classList.add(CLASS_START)
    if (info.edge) {
      cell.classList.add(CLASS_START_LAST)
    }

    cell.style.insetInlineStart = info.afterSelect ?
      `calc(var(--cui-data-grid-select-cell-width) + ${info.offset}px)` :
      `${info.offset}px`
  } else {
    cell.classList.add(CLASS_END)
    if (info.edge) {
      cell.classList.add(CLASS_END_FIRST)
    }

    cell.style.insetInlineEnd = `${info.offset}px`
  }
}
